export default __webpack_public_path__ + "static/media/tag.2e1f0def.svg";